<template>
  <div>
    <div v-if="impersonating" id="topbar">
      Viewing information for team
      <b>{{team.name}}</b>
      <button @click="switchBack">switch back</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["message"],
  computed: {
    ...mapGetters(["impersonating", "team"]),
    showTopBar() {
      return this.impersonating;
    }
  },
  methods: {
    ...mapActions(['enterTeam']),
    async switchBack() {
      await this.enterTeam(this.team.agency);
      console.log('switched back!');
      this.$router.push('/admin/teams');
    }
  }
};
</script>

<style scoped lang="scss">
@import "~scss/colors";

#topbar {
  /* position in middle of bar, on top of header, kind of like the iphone notch.
     this solution is used because there are header calculations that can't allow
     a taller header.
  */
  position: absolute;
  z-index: 15;

  /* position in middle */
  left: 50%;
  transform: translateX(-50%);

  /* make the message a kind of yellow notch */
  background: $admin-green-1;
  border: 1px solid $admin-green-0;
  color: $admin-green-0;
  border-top: none;
  padding: 2px 17px 5px 17px;
  border-radius: 0 0 3px 3px;

  font-size: 12pt;
  line-height: 12pt;
}

#topbar button {
  background: none;
  border: none;
  text-decoration: underline;
  padding-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TopBar.vue